/** 控制台 · 账号设置页（pages/console/settings.tsx）。 */
const messages = {
  'page.title': '账号设置',
  'page.description': '邮箱、密码与 Webhook 签名密钥。',

  cancel: '取消',
  done: '完成',

  'account.title': '账号',
  'account.description': '登录邮箱也用于接收验证码与运营通知。',
  'account.email': '邮箱',
  'account.verified': '已验证',
  'account.unverified': '未验证',
  'account.id': '账号 ID',
  'account.createdAt': '注册时间',
  'account.suspendedTitle': '账号已被停用。',
  'account.suspendedBody': '暂时无法提交新任务或启用 Key，请联系运营了解原因。',

  'password.title': '修改密码',
  'password.description': '修改后，其他设备上的登录会全部失效。',
  'password.currentRequired': '请输入当前密码',
  'password.newMin': '新密码至少 10 位',
  'password.newMax': '新密码最多 128 位',
  'password.mismatch': '两次输入的新密码不一致',
  'password.same': '新密码不能与当前密码相同',
  'password.changed': '密码已修改',
  'password.changedDescription': '其他设备上的登录已退出。',
  'password.error': '修改失败',
  'password.current': '当前密码',
  'password.new': '新密码',
  'password.newHint': '至少 10 位，建议混合字母、数字与符号。',
  'password.confirm': '确认新密码',
  'password.submit': '修改密码',
  'password.setTitle': '设置密码',
  'password.setDescription': '你目前只能用邮箱验证码登录。设置密码后，也可以用邮箱和密码登录。',
  'password.setSubmit': '设置密码',
  'password.setDone': '密码已设置',
  'password.setDoneDescription': '现在可以用邮箱和密码登录，其他设备上的登录已退出。',

  'webhook.title': 'Webhook 签名密钥',
  'webhook.set': '已设置',
  'webhook.notSet': '未设置',
  'webhook.description':
    '任务结束时，平台向 callback_url 推送事件，并用这个密钥签名。验签方法见<docs>文档</docs>。',
  'webhook.rotateHint': '轮换后会生成新密钥，旧密钥继续有效 24 小时，方便你无停机切换。',
  'webhook.emptyHint': '还没有密钥。生成后，带 callback_url 的任务会在终态时推送签名事件。',
  'webhook.rotate': '轮换密钥',
  'webhook.generate': '生成密钥',
  'webhook.generateFailed': '生成失败',
  'webhook.confirmTitle': '轮换 Webhook 签名密钥？',
  'webhook.confirm1': '新密钥只显示一次，请准备好更新接收服务的配置。',
  'webhook.confirm2': '旧密钥在 24 小时内仍可验签，之后失效。',
  'webhook.confirm3': '在此期间，请让接收服务同时接受新旧两个密钥。',
  'webhook.confirmAction': '生成新密钥',
  'webhook.revealTitle': '保存 Webhook 签名密钥',
  'webhook.revealDescription': '密钥只显示这一次。用它校验请求头 X-Signature 中的签名。',
  'webhook.copied': '密钥已复制',
  'webhook.copyFailed': '复制失败，请手动选中复制',
  'webhook.copyAgain': '已复制，可再次复制',
  'webhook.copy': '复制密钥',
  'webhook.savedConfirm': '我已把密钥保存到接收服务的配置中',

  'session.title': '退出登录',
  'session.description': '退出当前浏览器的登录。API Key 不受影响，已提交的任务继续处理。',
  'session.logout': '退出登录',

  'mfa.title': '两步验证',
  'mfa.description': '开启后，不论用密码还是邮箱验证码登录，都需要再输入验证器 App（如 Google Authenticator、1Password）上的动态码；即使邮箱被盗，别人也无法登录。',
  'mfa.on': '已开启',
  'mfa.off': '未开启',
  'mfa.onHint': '登录时需要输入动态码。验证器丢失时可用恢复码登录；恢复码也丢了，请联系客服核实身份后重置。',
  'mfa.offHint': '建议开启，即使密码或邮箱泄露，别人也无法登录。',
  'mfa.enable': '开启两步验证',
  'mfa.setupFailed': '生成密钥失败',
  'mfa.step1': '用验证器 App 扫描下方二维码，或手动输入密钥。',
  'mfa.step2': '输入 App 上显示的 6 位动态码完成开启。',
  'mfa.qr': '两步验证二维码',
  'mfa.manual': '无法扫码时手动输入密钥',
  'mfa.code': '动态码',
  'mfa.codeInvalid': '请输入 6 位数字',
  'mfa.confirm': '确认开启',
  'mfa.cancel': '取消',
  'mfa.enabled': '两步验证已开启',
  'mfa.enableFailed': '开启失败',
  'mfa.disable': '关闭两步验证',
  'mfa.disableTitle': '关闭两步验证',
  'mfa.disableDescription': '关闭后，登录不再需要动态码。',
  'mfa.byApp': '验证器动态码',
  'mfa.byRecovery': '恢复码',
  'mfa.recovery.title': '保存你的恢复码',
  'mfa.recovery.hint': '验证器丢失时，每个恢复码可代替动态码使用一次。它们只显示这一次，请保存到密码管理器或安全的地方。',
  'mfa.recovery.copy': '复制全部',
  'mfa.recovery.copied': '已复制',
  'mfa.recovery.copyFailed': '复制失败，请手动选择复制',
  'mfa.recovery.download': '下载 .txt',
  'mfa.recovery.fileHeader': 'aitoken.tools 两步验证恢复码（每个只能用一次）',
  'mfa.recovery.savedCheck': '我已妥善保存这些恢复码',
  'mfa.recovery.done': '完成',
  'mfa.recovery.left': '剩余 {n} 个可用恢复码',
  'mfa.recovery.regenerate': '换一组恢复码',
  'mfa.recovery.regenerateTitle': '换一组恢复码',
  'mfa.recovery.regenerateDescription': '输入动态码生成 10 个新恢复码，旧的会全部作废。',
  'mfa.recovery.regenerateFailed': '生成失败',
  'mfa.recovery.code': '恢复码',
  'mfa.recovery.codeHint': '格式如 ABCDE-23456，不区分大小写。',
  'mfa.disableConfirm': '确认关闭',
  'mfa.disabled': '两步验证已关闭',
  'mfa.disableFailed': '关闭失败',
};

export default messages;
